module.exports = __webpack_public_path__ + "static/img/create05.cb089e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/create05.svg
// module id = aH5j
// module chunks = 0